import { Fragment, useState } from 'react';
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import cx from "classnames";
import Mixedchart from "../charts/Mixedchart";
import Linechart from "../charts/Linechart";
import Groupedbarchart from "../charts/Groupedbarchart";
// import SelectBox from "components/elements/selectBox";
// import { MORE_FILTERS } from "../../constant";
import { formatNumberShort } from "components/Function";
import TimeRanger from "../../ui/timeRanger";

function Overview({ overview, sales_trending_cnt, sales_trending_gmv_amt, influencer_trending, video_trending, filter, setFilter }) {
    const { t } = useTranslation();
    const [type, setType] = useState("sales");

    return (
        <Fragment>
            <div className="card mt-5 mb-5 mb-xl-10">
                <div className="card-header border-0 cursor-pointer" role="button" data-bs-toggle="collapse" data-bs-target="#kt_account_profile_details" aria-expanded="true" aria-controls="kt_account_profile_details">
                    <div className="card-title m-0">
                        <h3 className="fw-bold m-0">{t("Overview")} ({(filter.dateRange || "30") + " days"})</h3>
                    </div>
                    <div className="col-md-3 position-relative my-5">
                        <div className="d-flex flex-column">
                            {/* <SelectBox
                                options={MORE_FILTERS["dateRange"].map((item) => ({
                                    value: item.id,
                                    label: item.name,
                                }))}
                                value={filter["dateRange"] || "30"}
                                placeholder={t("Select Date Range")}
                                onChange={(data) => {
                                    setFilter((prev) => ({
                                        ...prev,
                                        "dateRange": data.value || "",
                                    }));
                                }}
                            /> */}
                            <TimeRanger filter={filter} setFilter={setFilter} />
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-4">
                            <div className="row h-100">
                                {overview?.map((v, i) => {
                                    if (i % 2 === 0) {
                                        const first = overview[i];
                                        const second = overview[i + 1];

                                        return (
                                            <div key={i} className="d-flex align-items-center mb-3">
                                                <div className="col text-center">
                                                    <div className="fw-bold fs-2">{`${first?.prefix || ""} ${formatNumberShort(first?.value)}`}</div>
                                                    <div className="text-muted small">{first?.label}</div>
                                                </div>
                                                {second && <div className="vr mx-3" style={{ height: "100%" }}></div>}
                                                {second && (
                                                    <div className="col text-center">
                                                        <div className="fw-bold fs-2">{`${second?.prefix || ""} ${formatNumberShort(second?.value)}`}</div>
                                                        <div className="text-muted small">{second?.label}</div>
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    }
                                    return null;
                                })}
                            </div>
                        </div>
                        <div className="col-8">
                            <div className="col-12 d-flex justify-content-between mt-15">
                                <div>
                                    <h3 className="fw-bold">{t("Sales Trend")} ({(filter.dateRange || "30") + " days"})</h3>
                                </div>
                                <div className="btn-group">
                                    <button className={cx("btn", { "btn-primary": type === "sales", "btn-light": type !== "sales"})} onClick={() => setType("sales")} >
                                        {t("Sales")}
                                    </button>
                                    <button className={cx("btn", { "btn-primary": type === "gmv", "btn-light": type !== "gmv"})} onClick={() => setType("gmv")} >
                                        {t("GMV")}
                                    </button>
                                </div>
                            </div>
                            <div className="d-flex">
                                <div className="d-flex col">
                                    <Mixedchart sales_trending_cnt={sales_trending_cnt} sales_trending_gmv_amt={sales_trending_gmv_amt} type={type} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex mt-10">
                        <div className="d-flex col">
                            <Linechart influencer_trending={influencer_trending} filter={filter} />
                        </div>
                        <div className="d-flex col">
                            <Groupedbarchart video_trending={video_trending} filter={filter} />
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

const mapStateToProps = state => ({
});
const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(Overview);